import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19e8c496"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "i-guidance" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "跳转中，请稍后...", -1))
const _hoisted_3 = [
  _hoisted_2
]

import {onMounted} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import useSelf from '@/hooks/useSelf'
import api from './api'
import storageKeys from '@/tools/storage-keys'
import {EVENT_NODE_TYPE, trackEvent} from '@/tools/track-event'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const self = useSelf()

// 暂时注释以解决每次登录都要选择院区的 bug
// 暂时不知道对别的是否有什么影响
// 所以将原来的全部清空，修改为只清空 TID 和 USER_INFO
// 清空所有的 localStorage
// localStorage.clear()
localStorage.removeItem('TID')
localStorage.removeItem('USER_INFO')

// 从地址栏获取 mobile, from, currentUserId 参数
const {
  mobile,
  from,
  currentUserId,
  envVersion,
  token
} = route.query as any

// 登录方式
let loginMethod = ''

// 根据地址上的参数的值，
// 判断登录方式为 THIRD-PARTY 或 SMALL_PROGRAM
// 否则视为登录失败
if (mobile && from) {
  loginMethod = 'THIRD-PARTY'
} else if (currentUserId) {
  loginMethod = 'SMALL_PROGRAM'
} else {
  self.$toast('自动登录失败，请手动进行登录！')
  // 清空 localStorage
  localStorage.clear()
  router.replace({path: '/login'})
}

// 登录
const login = async () => {
  try {
    let tid = ''
    if (loginMethod === 'THIRD-PARTY') {
      const params = {mobile, from}
      tid = await api.loginFromThirdParty(params)
      trackEvent({
        nodeType: EVENT_NODE_TYPE.用户第三方登录,
        pageName: route.meta.title as string,
        url: '/i-guidance/user/no-pass-login',
        reqParam: JSON.stringify(params),
        resParam: tid
      })
    }
    if (loginMethod === 'SMALL_PROGRAM') {
      const params = {
        param: currentUserId,
        env: envVersion
        // token
      }
      tid = await api.loginFromSmallProgram(params)
      trackEvent({
        nodeType: EVENT_NODE_TYPE.用户第三方登录,
        pageName: route.meta.title as string,
        url: '/i-guidance/user/ehos-login',
        reqParam: JSON.stringify(params),
        resParam: tid
      })
    }
    localStorage.setItem(storageKeys.TID, tid)
    const userInfo = await api.getUserInfo()
    localStorage.setItem(storageKeys.USER_INFO, JSON.stringify(userInfo))
    self.$toast.success('登录成功')
    await router.replace({
      path: '/hospital-list',
      query: {
        fromPath: '/i-guidance'
      }
    })
  } catch (e) {
    await router.replace({path: '/login'})
    self.$toast(e.message)
  }
}

onMounted(() => {
  setTimeout(login, 2000)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})